import React from "react";
import Paginator from "./../shared/paginator.jsx";
import moment from "moment";
import context from "./../../lib/context.js";
import ajax from "./../../lib/context.js";

export default class ChangeLogList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let items = [];

        let vm = this.props.vm; // Expected to be an array of listItem
        let totalPage = vm.total / vm.pageSize + 
            (vm.total % vm.pageSize > 0 ? 1 : 0); 
        if (vm == null || vm.changeLogs == null || vm.changeLogs == 0) {
            return(
                <div className="ap-fullsize ap-grid-result text-center">
                    No Change Logs Found!
                </div>
                );
        } else {
            for(let i=0; i<vm.changeLogs.length; i++) {
                let tc = vm.changeLogs[i];
                items.push(
                    <div className="row ap-timecard-list-item">
                        <section className="hidden-sm hidden-xs">
                            <div className="col-md-4 col-lg-4" title={"#" + tc.timecardId + "," + tc.timecardStatus}>
                                <span style={{paddingRight: "10px"}}>
                                    <input type="checkbox" className="ap-header-checkbox"
                                        checked={tc.isChecked === true} 
                                        onChange={() => this.props.onTcItemChecked(i)}/>
                                </span>
                                <span style={{paddingRight: "10px"}}>
                                    {tc.peopleName}
                                </span>
                                
                                <a className="ap-clickable-icon" title="Show/Hide Notes" onClick={() => this.props.onToggleNotes(i)}>
                                    <i className={tc.showNotes? "fa fa-minus-square-o": "fa fa-plus-square-o"}></i>
                                </a>
                            </div>
                            <div className="col-md-1 col-lg-1 ap-color-darkgray">
                                {moment(tc.weekEnding).format("MM/DD/YYYY")}
                            </div>
                            <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                                {tc.regularHour} : {tc.regularMin}
                            </div>
                            <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                                {tc.otHour} : {tc.otMin}
                            </div>
                            <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                                {tc.dtHour} : {tc.dtMin}
                            </div>
                            <div className="col-md-1 col-lg-1 text-center ap-color-darkgray">
                                {tc.miscHour} : {tc.miscMin}
                            </div> 
                            <div className="col-md-3 col-lg-3 ap-color-darkgray">
                                {tc.actionOperatorName}
                            </div>
                        </section>
                        <section className="hidden-md hidden-lg">
                            <div className="col-xs-6 col-sm-6">
                                <b>{moment(tc.weekEnding).format("MM/DD/YYYY")}</b>
                                
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span style={{paddingRight: "5px"}}>
                                    <input type="checkbox"
                                        checked={tc.isChecked === true} 
                                        onChange={() => this.props.onTcItemChecked(i)}/>
                                </span>
                                <a className="ap-clickable-icon" title="Show/Hide Notes" onClick={() => this.props.onToggleNotes(i)}>
                                    <i className={tc.showNotes? "fa fa-minus-square-o": "fa fa-plus-square-o"}></i>
                                </a>
                            </div>
                            <div className="col-xs-12 col-sm-12">
                                {tc.peopleName}
                            </div> 
                            <div className="col-xs-12 col-sm-12">
                                <span className="ap-color-gray">Changed By </span>
                                {tc.actionOperatorName}
                            </div>
                            <div className="col-xs-12 col-sm-12">
                                <span className="ap-color-gray">Timecard </span>
                                #{tc.timecardId}, {tc.timecardStatus}
                            </div>  
                            <div className="col-xs-12 col-sm-12 ap-separator-col">                        
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Regular Time </span><br/>
                                <b>{tc.regularHour} : {tc.regularMin}</b>
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Over Time </span><br/>
                                <b>{tc.otHour} : {tc.otMin}</b>
                            </div>
                            <div className="col-xs-12 col-sm-12 ap-separator-col">              
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Double Time </span><br/>
                                <b>{tc.dtHour} : {tc.dtMin}</b>
                            </div>
                            <div className="col-xs-6 col-sm-6">
                                <span className="ap-color-gray">Misc </span><br/>
                                <b>{tc.miscHour} : {tc.miscMin}</b>
                            </div>  
                            <div className="col-xs-12 col-sm-12 ap-separator-col">          
                            </div>
                        </section>
                        <section className={tc.showNotes? "": "hidden"}>
                            <div className="row">
                                <div className="col-md-1 col-lg-1">&nbsp;</div>
                                <div className="col-md-11 col-lg-11">
                                    {tc.notes.split("\n").map(i => {
                                        return <div>{i}</div>;
                                    })}
                                    <div>Due to: {tc.reason}</div>
                                </div>
                            </div>
                        </section>
                    </div>
                    );              
            }
        }

        return(
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="container-fluid ap-timecard-list-header">
                            <div className="row">
                                <div className="hidden-xs hidden-sm col-md-4 col-lg-4 ap-col-title">
                                    <span style={{paddingRight: "10px"}}>
                                        <input type="checkbox" className="ap-header-checkbox"
                                            checked={vm.isAllSelected === true} 
                                            onChange={() => this.props.onTcItemChecked("all")}/>
                                    </span>
                                    Associate
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    Week Ending
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    Regular hour/min
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    OverTime hour/min
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    DoubleTime hour/min
                                </div>
                                <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                    Misc Hours
                                </div>
                                <div className="hidden-xs hidden-sm col-md-3 col-lg-3 ap-col-title">
                                    Changed By
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="row">                        
                    <div className="col-lg-12">                            
                        <div className="container-fluid ap-timecard-list">
                            {items}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Paginator total={totalPage} range="3" selectedIndex={vm.page} 
                            onNavigate={this.props.onNavigate}  />
                    </div>
                </div>
            </div>
        );
    }
}